var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.608,
    height: 42.608,
    viewBox: "0 0 42.608 42.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_63",
    "data-name": "Grupo 63",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1058",
    "data-name": "Trazado 1058",
    d: "M969.8-728.06a20.3,20.3,0,0,1-20.3,20.3,20.3,20.3,0,0,1-20.3-20.3,20.3,20.3,0,0,1,20.3-20.3A20.3,20.3,0,0,1,969.8-728.06Z",
    transform: "translate(-929.191 748.364)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1059",
    "data-name": "Trazado 1059",
    d: "M1057.552-654.2h5.211v-13.051h3.636l.388-4.37h-4.024v-2.489c0-1.03.207-1.438,1.2-1.438h2.821v-4.535h-3.609c-3.878,0-5.626,1.708-5.626,4.978v3.484h-2.711v4.425h2.711Z",
    transform: "translate(-1040.52 687.864)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4aa91f8be12b5a81ee1a4f9c4f022250.svg";
export { ForwardRef as ReactComponent };